module.exports = __webpack_public_path__ + "img/icon-exclusion.c5aafd35.svg";